import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  signal,
} from '@angular/core';
import { Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-invoice-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-invoice-dialog.component.html',
  styleUrl: './confirm-invoice-dialog.component.scss',
})
export class ConfirmInvoiceDialogComponent {
  confirmed = false;
  organization_source = 'BEIZY';

  constructor(
    public dialogRef: MatDialogRef<ConfirmInvoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      organization_source: string;
    },
  ) {
    this.organization_source = data.organization_source;

    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il suo contorno e la fascia panna delle azioni
       non sono raggiungibili da uno stile incapsulato: servono le regole
       globali di .izy-info-dialog-panel, la veste neutra dei dialog che
       informano o raccolgono un consenso senza distruggere niente.
       .izy-auto-height-dialog-panel toglie in piu' l'altezza fissa (400px) che
       i chiamanti passano alla MatDialogConfig.
       Sono le stesse due classi del dialog che segue nel flusso, la conferma
       dell'indirizzo email: i tre passaggi dell'invio si leggono come una
       sequenza sola. Le aggiunge il componente e non il chiamante perche' i
       punti di apertura sono quattro (nuova fattura, dettaglio fattura,
       bozze, fattura veloce) e la veste e' la stessa per tutti. */
    this.dialogRef.addPanelClass([
      'izy-info-dialog-panel',
      'izy-auto-height-dialog-panel',
    ]);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  legalConditionsRedirect() {
    window.open('https://www.beizy.it/legal', '_blank');
  }
}
